var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoublearrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9297 15.8984C16.1406 15.6875 16.1406 15.3359 15.9297 15.125L11.3828 10.5547C11.1484 10.3438 10.7969 10.3438 10.5859 10.5547L10.0469 11.0938C9.83594 11.3047 9.83594 11.6562 10.0469 11.8906L13.6562 15.5L10.0469 19.1328C9.83594 19.3672 9.83594 19.7188 10.0469 19.9297L10.5859 20.4688C10.7969 20.6797 11.1484 20.6797 11.3828 20.4688L15.9297 15.8984Z",
    fill: "#363ED3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9297 15.8984C21.1406 15.6875 21.1406 15.3359 20.9297 15.125L16.3828 10.5547C16.1484 10.3438 15.7969 10.3438 15.5859 10.5547L15.0469 11.0938C14.8359 11.3047 14.8359 11.6562 15.0469 11.8906L18.6562 15.5L15.0469 19.1328C14.8359 19.3672 14.8359 19.7188 15.0469 19.9297L15.5859 20.4688C15.7969 20.6797 16.1484 20.6797 16.3828 20.4688L20.9297 15.8984Z",
    fill: "#363ED3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoublearrowRight);
export default __webpack_public_path__ + "static/media/icon-doublearrow-right.3b821788c198ff6055fc4c5e4f1fb967.svg";
export { ForwardRef as ReactComponent };